export default __webpack_public_path__ + "static/media/eventTextSelection.62552c35.png";